export default __webpack_public_path__ + "static/spinach-e9f02d78bc5d5e30a07d451086a78316.webp";